import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { Alerts911Model } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage911-alerts',
  templateUrl: './manage911-alerts.component.html',
  styleUrls: ['./manage911-alerts.component.css']
})
export class Manage911AlertsComponent implements OnInit {

  tokenKey: string = '';
  userId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  multiSelectDropDownHeight: number = 200;


  Alerts911Model = new Alerts911Model()

  addUpdate911Alert = new FormGroup({
    updateId: new FormControl(''),
    updateDate: new FormControl(''),
    note: new FormControl(''),
    isNotify: new FormControl(0),
  });

  is911Alerts: boolean = true;
  updateId: number = 0;
  isDataLoad: boolean = false;
  isViewMode: boolean = false;

  isNotify: boolean = true;

  pageNumber:number;
  pageSize:number;
  Email:string = '';
  Name:string = '';
  orderBy:string;
  fundName:string ='';

  constructor(private readonly activedRoute: ActivatedRoute, private readonly checkAuth: CheckAuth, public readonly trfaAlertServices:TrfaAlertService,private readonly toastr: ToastrService, private readonly router: Router,private readonly titleService: Title, private sessionStorageService: SessionStorageService) {
      this.tokenKey = this.sessionStorageService.getTokenValue();
      this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
      this.SelectedTool = this.sessionStorageService.getUserLoginTool();
      this.productId = ToolEnum.state911;
      this.titleService.setTitle('Manage 911 Alert');
    }


  ngOnInit() {
    this.pageNumber = 1;
    this.pageSize = 10;
    this.orderBy = 'updateId ASC'
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          this.is911Alerts = false;
          this.updateId = params['id'];
          this.userId = params['userid'];
          this.Get911AlertsByUsers();
        }
      }
      else {
        this.userId = 0;
      }
    });
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  
  Get911AlertsByUsers(): void {
    this.isDataLoad = true;
    this.trfaAlertServices.Get911AlertsByUser(this.tokenKey, this.updateId,this.pageNumber,this.pageSize,this.userId,this.orderBy).subscribe(
      data => {
        if (data["alert911user"] != null && data["status"] != "Failure") {

          this.Alerts911Model = data['alert911user'][0];

          this.Email=this.Alerts911Model.email;
          this.Name=this.Alerts911Model.name;
          this.fundName=this.Alerts911Model.fundName;

          if (this.Alerts911Model != null) {
            const updateDate = new Date(this.Alerts911Model.updateDate);
          
            let dd1 = updateDate.getDate().toString();
            if (parseInt(dd1) < 10) {
              dd1 = '0' + dd1;
            }
          
            let mm1 = (updateDate.getMonth() + 1).toString();
            if (parseInt(mm1) < 10) {
              mm1 = '0' + mm1;
            }
          
            this.Alerts911Model.updateDate = `${mm1}/${dd1}/${updateDate.getFullYear()}`;
          }

          this.addUpdate911Alert.setValue({
            updateId: this.Alerts911Model.updateId,
            updateDate: this.Alerts911Model.updateDate,
            note: this.Alerts911Model.note,
            isNotify: this.Alerts911Model.isNotify
          });

          this.isDataLoad = false;
        }
        else {
          this.isDataLoad = false;
          this.showMessage(data["message"], 'Error', 'error');
        }
      }, error => {
        this.isDataLoad = false;
        this.showMessage(error, 'Error', 'error');
      })

  }


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  isAlertDate(dateArray: any) {
    if (dateArray != null) {
      let dd1 = dateArray.getDate().toString();
      if (parseInt(dd1.toString()) < 10)
        dd1 = '0' + dd1.toString();

      let mm1 = (dateArray.getMonth() + 1).toString();
      if (parseInt(mm1.toString()) < 10)
        mm1 = '0' + mm1.toString();

      this.Alerts911Model.updateDate = mm1 + '/' + dd1 + '/' + dateArray.getFullYear();
    }
    else
      this.Alerts911Model.updateDate = null;
  }

  saveAddUpdate911Alert(addUpdate911Alert: any) {
    if (addUpdate911Alert.value['updateDate'] == '') {
      this.showMessage('Please select alert date', 'Error', 'error');
      return;
    }
    let currentDate = new Date();
    if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdate911Alert.value["updateDate"]) {
      this.showMessage('Previous alert date not allow', 'Error', 'error');
      return;
    }

    if (addUpdate911Alert.value['note'] == '' || typeof (addUpdate911Alert.value['note']) == 'undefined') {
      this.showMessage('Please enter note', 'Error', 'error');
      return;
    }
    if (addUpdate911Alert.value['note'] != '') {
      if (addUpdate911Alert.value['note'].toString().trim() == '') {
        this.showMessage('Please enter note', 'Error', 'error');
        return;
      }
    }

    if (typeof (addUpdate911Alert.value['updateId']) == 'undefined') {
      this.Alerts911Model.updateId = 0;
    }
    else {
      this.Alerts911Model.updateId = addUpdate911Alert.value['updateId'];
    }

    if (typeof (addUpdate911Alert.value['note']) == 'undefined') {
      this.Alerts911Model.note = '';
    }
    else {
      this.Alerts911Model.note = addUpdate911Alert.value['note'];
    }

    this.Alerts911Model.isNotify = this.isNotify;
    this.Alerts911Model.userId = this.userId;
    this.Alerts911Model.productId=this.productId;
   
    this.trfaAlertServices.addUpdate911Alerts(this.tokenKey, this.Alerts911Model).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('911 alerts Updated successfully', 'Success', 'success');
          this.router.navigate(['/admin/911/911-Alerts']);
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  setSendEmailNotificationChecked($event) {
    this.isNotify = $event.target.checked;
  }
}
